import React, { useEffect, useRef } from "react";
import { NavLink } from 'react-router-dom'
import slider1 from '../assets/slider/kids/slider-1.jpg';
import image1 from '../assets/slider/kids/section5-image1.png';
import image2 from '../assets/slider/kids/section5-image2.png';
import image3 from '../assets/slider/kids/section5-image3.png';
import image4 from '../assets/slider/kids/section5-image4.png';

import kidsBanner from '../assets/kids-banner.jpg';
import okaidiImage from '../assets/brandImages/kids/okaidi.jpg';
import guessImage from '../assets/brandImages/kids/guess-kids.jpg';
import geoxImage from '../assets/brandImages/kids/geox-kids.jpg';
import timberlandImage from '../assets/brandImages/kids/timberland-kids.jpg';

import video from '../assets/slider/kids/video-kids.webm';

import Products2 from "./Products2";
import Productslider from "./Productslider";
import Productslider2 from "./Productslider2";


import './Header.css';
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Autoplay} from "swiper";
// import "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css";

export default function Kids() {

  const vidRef = useRef();

  useEffect(() => {
    // vidRef.current.play();
  }, []);

  return (

    <div className="bg-gradient-to-b from-neutral-50 to-white">
        <div className="cover-section">
            <Swiper
                slidesPerView={1}
                spaceBetween={0}
                loop={true}
                centeredSlides={true}
                pagination={false}
                navigation={false}
                modules={[Autoplay]}
                autoplay={{
                    delay: 15000,
                    disableOnInteraction: false,
                }}
                className="mySwiper"
            >
                        <SwiperSlide>
                            <NavLink
                                to="/search/kids"
                                aria-label="Shiko koleksionin"
                                className="block relative albi-grain cursor-pointer"
                            >
                                <img
                                    className={'slider-image max-h-[380px] sm:max-h-[500px] lg:max-h-[560px] object-cover'}
                                    src={kidsBanner}
                                    alt={'AlbiKids'}
                                    width="100%"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-black/5 to-transparent pointer-events-none" />
                            </NavLink>
                        </SwiperSlide>
                        <SwiperSlide>
                            <NavLink
                                to="/search/kids"
                                aria-label="Shiko koleksionin"
                                className="block relative albi-grain cursor-pointer"
                            >
                                <img
                                    className={'slider-image max-h-[380px] sm:max-h-[500px] lg:max-h-[560px] object-cover'}
                                    src={slider1}
                                    alt=""
                                    width="100%"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-black/5 to-transparent pointer-events-none" />
                            </NavLink>
                        </SwiperSlide>
            </Swiper>
        </div>

        <div className="cart-section mt-10 sm:mt-20">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="flex items-end justify-between gap-6 py-4">
                    <div>
                        <div className="text-[11px] font-semibold tracking-[0.22em] text-neutral-500 uppercase">
                            new collection
                        </div>
                        <div className="title_block !mt-1">
                            Më të rejat
                        </div>
                    </div>
                    <NavLink
                        to="/new-arrivals?gender=kids"
                        className="inline-flex items-center gap-2 rounded-full border border-neutral-200 bg-white px-4 py-2 text-xs font-semibold tracking-wide text-neutral-800 shadow-sm hover:border-neutral-300 hover:bg-neutral-50 transition-colors"
                    >
                        Shiko më shumë
                        <span aria-hidden="true">→</span>
                    </NavLink>
                </div>
            </div>
            <Productslider start='1' limit='20' gender='kids' type='newin' dataSource='new-arrivals' eager prefetchPx={2000}/>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-9">
                <div className="flex items-end justify-between gap-6 py-4">
                    <div>
                        <div className="text-[11px] font-semibold tracking-[0.22em] text-neutral-500 uppercase">
                            top picks
                        </div>
                        <div className="title_block !mt-1">
                            Top Zgjedhjet
                        </div>
                    </div>
                    <NavLink
                        to="/top-picks?gender=kids"
                        className="inline-flex items-center gap-2 rounded-full border border-neutral-200 bg-white px-4 py-2 text-xs font-semibold tracking-wide text-neutral-800 shadow-sm hover:border-neutral-300 hover:bg-neutral-50 transition-colors"
                    >
                        Shiko më shumë
                        <span aria-hidden="true">→</span>
                    </NavLink>
                </div>
            </div>
            <Productslider start='1' limit='20' gender='kids' type='toppicks' dataSource='top-picks' eager prefetchPx={2000}/>
        </div>

      <div className='section-5 video-sec'>
        <div id="shopify-section-16141564777b64a0a2" className="shopify-section index-section section-video wow fadeInUp  animated">

          <div data-section-id="16141564777b64a0a2">
            <div className="distance">
              <div className="container-1320">
                <div className="block">
                  <div className="item youtube position-relative rounded-2xl overflow-hidden shadow-sm ring-1 ring-black/5">
                    <video src={video} muted autoPlay loop width='100%' height='100%' webkit-playsinline="true" playsInline />

                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-10">
            <div className="text-[11px] font-semibold tracking-[0.22em] text-neutral-500 uppercase text-center">
                Brendet
            </div>
            <div className="title_block text-center w-full !mt-1">
                Në Fokus
            </div>
        </div>
 <div className={'brand-focus-slider kids-brand-focus'}>
     <NavLink to={`/brands/okaidi`} aria-label={'okaidi'}
        className="group w-full p-4 flex items-center justify-center">
         <div
             className="w-full h-full flex items-center justify-center bg-gray-50 rounded-md overflow-hidden shadow-sm transition transform grayscale group-hover:grayscale-0 group-hover:scale-105 group-hover:-translate-y-2 group-hover:shadow-2xl">
                            <span className={'absolute bottom-0 left-0 p-1 w-full rounded-tl-md'} style={{
                                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                backdropFilter: 'blur(10px)',
                            }}>
                                <img
                                    style={{height: 150,margin: '-25px 0'}}
                                    src={'https://appapi.albionline.com/vendorImages/Okaidi.svg'}
                                    alt={'okaidi'}
                                    className="mx-auto object-contain w-full"
                                    loading="lazy"
                                    width="200"
                                    height="100"
                                />
                            </span>
             <img
                 src={okaidiImage}
                 alt={'okaidi'}
                 className="w-full"
                 loading="lazy"
                 width="200"
                 height="80"
             />
         </div>
     </NavLink>
     <NavLink to={`/brands/guess`} aria-label={'guess'}
        className="group w-full p-4 flex items-center justify-center">
         <div
             className="w-full h-full flex items-center justify-center bg-gray-50 rounded-md overflow-hidden shadow-sm transition transform grayscale group-hover:grayscale-0 group-hover:scale-105 group-hover:-translate-y-2 group-hover:shadow-2xl">
                            <span className={'absolute bottom-0 left-0 p-1 w-full rounded-tl-md'} style={{
                                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                backdropFilter: 'blur(10px)',
                            }}>
                                <img
                                    style={{height: 150,margin: '-25px 0'}}
                                    src={'https://appapi.albionline.com/vendorImages/Guess.svg'}
                                    alt={'guess'}
                                    className="mx-auto object-contain w-full"
                                    loading="lazy"
                                    width="200"
                                    height="100"
                                />
                            </span>
             <img
                 src={guessImage}
                 alt={'guess'}
                 className="w-full"
                 loading="lazy"
                 width="200"
                 height="80"
             />
         </div>
     </NavLink>
     <NavLink to={`/brands/timbreland`} aria-label={'timbreland'}
              className="group w-full p-4 flex items-center justify-center">
         <div
             className="w-full h-full flex items-center justify-center bg-gray-50 rounded-md overflow-hidden shadow-sm transition transform grayscale group-hover:grayscale-0 group-hover:scale-105 group-hover:-translate-y-2 group-hover:shadow-2xl">
                            <span className={'absolute bottom-0 left-0 p-1 w-full rounded-tl-md'} style={{
                                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                backdropFilter: 'blur(10px)',
                            }}>
                                <img
                                    style={{height: 150,margin: '-25px 0'}}
                                    src={'https://appapi.albionline.com/vendorImages/Timberland.svg'}
                                    alt={'timbreland'}
                                    className="mx-auto object-contain w-full"
                                    loading="lazy"
                                    width="200"
                                    height="100"
                                />
                            </span>
             <img
                 src={timberlandImage}
                 alt={'timbreland'}
                 className="w-full"
                 loading="lazy"
                 width="200"
                 height="80"
             />
         </div>
     </NavLink>
     <NavLink to={`/brands/geox`} aria-label={'geox'}
              className="group w-full p-4 flex items-center justify-center">
         <div
             className="w-full h-full flex items-center justify-center bg-gray-50 rounded-md overflow-hidden shadow-sm transition transform grayscale group-hover:grayscale-0 group-hover:scale-105 group-hover:-translate-y-2 group-hover:shadow-2xl">
                            <span className={'absolute bottom-0 left-0 p-1 w-full rounded-tl-md'} style={{
                                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                backdropFilter: 'blur(10px)',
                            }}>
                                <img
                                    style={{height: 150,margin: '-25px 0'}}
                                    src={'https://appapi.albionline.com/vendorImages/Geox.svg'}
                                    alt={'geox'}
                                    className="mx-auto object-contain w-full"
                                    loading="lazy"
                                    width="200"
                                    height="100"
                                />
                            </span>
             <img
                 src={geoxImage}
                 alt={'geox'}
                 className="w-full"
                 loading="lazy"
                 width="200"
                 height="80"
             />
         </div>
     </NavLink>
 </div>
    </div>
  )
}